import styled from "styled-components";

export const AddModal = styled.div`
  width: 36.5rem;

  .date {
    margin: 0 auto;
    width: 100%;

    div {
      width: 100%;
    }
  }

  .date-range h2 {
    margin: 1rem 0;
  }

  .fields {
    display: flex;
    /* flex-direction: column; */
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: space-between;

    h1 {
      font-size: 1.5rem;
    }

    .divider {
      margin: 0.4rem 0;
    }
  }
`;
